/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q5_QuestionInputs */

const en_faq_q5_question = /** @type {(inputs: Faq_Q5_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does “eligibility” mean?`)
};

const fr_faq_q5_question = /** @type {(inputs: Faq_Q5_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifie « admissibilité » ?`)
};

/**
* | output |
* | --- |
* | "What does “eligibility” mean?" |
*
* @param {Faq_Q5_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q5_question = /** @type {((inputs?: Faq_Q5_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q5_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q5_question(inputs)
	return fr_faq_q5_question(inputs)
});